function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.06.832H9.485V.66C9.485.1,9.023,0,8.459,0H5.522C4.958,0,4.5.1,4.5.66V.832H.939a.608.608,0,0,0-.609.609V2.617a.609.609,0,0,0,.609.609H13.06a.609.609,0,0,0,.609-.609V1.441A.609.609,0,0,0,13.06.832Z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.782,4.844H2.217a.61.61,0,0,0-.6.685l.981,7.422A1.2,1.2,0,0,0,3.781,14h6.437a1.2,1.2,0,0,0,1.188-1.049l.98-7.422A.609.609,0,0,0,11.782,4.844Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 14 14"
  }, props), _ref, _ref2);
};
export default __webpack_public_path__ + "static/media/trashbin.6c429e94.svg";
export { SvgComponent as ReactComponent };